import { render, staticRenderFns } from "./ContractProvidersTable.vue?vue&type=template&id=770c51b2&"
import script from "./ContractProvidersTable.vue?vue&type=script&lang=js&"
export * from "./ContractProvidersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports